module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "app"
    }
  }, [_c('logo'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.allowEntranceSubmit) ? _c('loading') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.authorized) ? _c('entrance', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.allowEntranceSubmit),
      expression: "allowEntranceSubmit"
    }]
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.authorized) ? _c('chat') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-204c1974!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 170
// module chunks = 2